// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__L585f","loading":"skeleton_loading__dPq5K"};